<template>
<div class="d-flex">
      <div>
        <p class="detail-table-name">Working Day</p>
        <table class="detail-table w-100">
          <thead>
          <tr>
            <th></th>
            <th>Attendance</th>
            <th>Late</th>
            <th>Absent</th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="workingDay of workingDays" :key="workingDay.index">
              <td>{{ workingDay.term | term }}</td>
              <td>{{ workingDay.attendance }}</td>
              <td>{{ workingDay.late }}</td>
              <td>{{ workingDay.absent }}</td>
            </tr>
            <tr v-if="isPending()">
              <td>Academic Year</td>
              <td colspan="3"> {{ pendingStatus }} </td>
            </tr>
            <tr v-else>
              <td>Academic Year</td>
              <td>{{ yearlyWorkingDays[0].attendance }}</td>
              <td>{{ yearlyWorkingDays[0].late }}</td>
              <td>{{ yearlyWorkingDays[0].absent }}</td>
            </tr>
          </tbody>
        </table>
        <p class="unit-name">Unit: Days</p>
      </div>
    </div>
</template>

<script lang="ts">
import _ from 'lodash'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { RootState } from '@/store/types'
import { Timesheet, WorkingDay } from '@/store/timesheets/types'
import { Moment } from 'moment'

@Component({
  filters: {
    term: (value: string): string => (value === 'fiscalYear' ? 'Academic Year' : _.upperFirst(value)),
  },
})
export default class WorkingDayComponent extends Vue {
  @Prop() date!: Moment

  @Prop() workingDays!: WorkingDay[]

  private pendingStatus: string = 'Data is pending ...'

  created() {
    this.$store.dispatch('getYearlyWorkingDay', {
      tutorId: this.$route.params.tutorId,
      yearMonth: this.date.format('YYYYMM'),
    })
      .then(() => {
        this.pendingStatus = 'finished'
      })
  }

  private get yearlyWorkingDays() {
    return this.$store.state.timesheets.yearlyworkdays
  }

  private isPending() {
    return this.pendingStatus === 'Data is pending ...'
  }
}
</script>

<style scoped>
.detail-table-name {
  border-left:3px solid #BFBFBF;
  padding-left:5px;
  margin-bottom:10px;
  font-weight: bold;
}

.detail-table {
  table-layout: fixed;
  border-collapse:collapse;
  margin-bottom:10px;
}

.detail-table th {
  padding:10px;
  text-align: center;
}

.detail-table td {
  padding:10px;
  text-align: center;
}

.detail-table thead tr {
  background: #fff;
  border: 2px solid #dcdcdc
}

.detail-table tbody tr:nth-child(odd) {
  background: #D8D8D8;
}

.detail-table tbody tr:nth-child(even) {
  background: #fff;
}

.detail-table tbody tr.total {
  background: #D8E2F3;
}

.unit-name {
  text-align: right;
}
</style>
